import React, { useContext } from 'react';
import { Typography, Divider, Price } from 'fronton-react';
import { useRecoilValue } from 'recoil';
import { css } from 'linaria';
import { styled } from 'linaria/react';
import { dimensionsAtom } from 'pages/dimensions/store/dimensions';
import { DataContext } from 'entries/common/widgets/context';
import { useCalculationState } from 'pages/calculation/store/calculation';
import { getTotalCostComplimentaryProducts } from 'common/helpers/get-total-cost-complimentary-products.helper';
import { Cart } from '../CalculationFooter/Cart';

export const AddToCart = () => {
  const remoteData = useContext(DataContext);
  const { calculationFormState, totalAmount } = useCalculationState();
  const dimensions = useRecoilValue(dimensionsAtom);
  const { complimentaryProductInfo, checkedProducts } = dimensions;
  const totalPriceOfComplimentaryProducts = !!complimentaryProductInfo.length
    ? getTotalCostComplimentaryProducts({ complimentaryProductInfo, checkedProducts })
    : 0;
  const totalMainItem = totalAmount - totalPriceOfComplimentaryProducts;

  if (remoteData) {
    const { productId } = remoteData;
    const count = Number(calculationFormState.count);

    return (
      <AddToCartWrapper>
        <ResultSummWrapper>
          <Typography size="body_short" variant="s" color="text-primary">
            Основной товар
          </Typography>
          <Price
            align="right"
            fraction
            size="s"
            value={totalMainItem}
            variant="regular"
            className={PriceResultClassname}
          />
        </ResultSummWrapper>
        {complimentaryProductInfo.length ? (
          <ResultSummWrapper>
            <Typography size="body_short" variant="s">
              Расходники и инструменты
            </Typography>
            <Price
              align="right"
              fraction
              size="s"
              value={totalPriceOfComplimentaryProducts}
              variant="regular"
              className={PriceResultClassname}
            />
          </ResultSummWrapper>
        ) : null}

        <Divider orientation="horizontal" variant="line" />
        <ResultSummWrapper isLast>
          <Typography size="body_accent" variant="l">
            Итого
          </Typography>
          <Price
            align="right"
            fraction
            size="xl"
            value={totalAmount}
            variant="medium"
            data-testid="calculation-price"
          />
        </ResultSummWrapper>
        <Cart count={count} productId={productId} />
      </AddToCartWrapper>
    );
  }

  return null;
};

const AddToCartWrapper = styled.div`
  position: sticky;
  top: 72px;
  display: flex;
  flex-direction: column;
  gap: var(--space-200);
  box-sizing: border-box;
  width: 372px;
  height: auto;
  padding: var(--space-400);
  background-color: var(--background-secondary);
  border-radius: 8px;

  @media (max-width: 1024px) {
    width: 100%;
  }
  @media (--only-mobile) {
    position: relative;
    height: auto;
    padding: var(--space-300);
  }
`;

const ResultSummWrapper = styled.div<{ isLast?: boolean }>`
  position: relative;
  display: flex;
  justify-content: space-between;
  margin-bottom: ${props => (props.isLast ? 'var(--space-100)' : '0px')};
`;

const PriceResultClassname = css`
  width: auto;
`;
